import React from 'react'
import { Breakpoint } from 'react-socks'

export default ({ children }) => (
  <Breakpoint desktopLow up>
    {children}
  </Breakpoint>
)
